import React from 'react'

import { Menu } from '@mantine/core' // assuming you are using Mantine

import DNButton from 'src/components/Buttons/Button/DNButton'

type MenuItem = {
  label: string | React.ReactElement
  hidden?: boolean
  onClick: () => void
  disabled?: boolean
}

interface ActionsMenuProps {
  text: string
  items: MenuItem[]
  leftIcon?: React.ReactElement
  rightIcon?: React.ReactElement
}

const ActionsMenu = ({
  text,
  items,
  leftIcon,
  rightIcon,
}: ActionsMenuProps) => {
  return (
    <Menu position="bottom-end" offset={3} withArrow shadow="md">
      <Menu.Target>
        <DNButton variant="primary" type="button">
          {leftIcon}
          {text}
          {rightIcon}
        </DNButton>
      </Menu.Target>
      <Menu.Dropdown>
        {items
          .filter((item) => !item.hidden)
          .map((item, index) => (
            <Menu.Item
              className="text-sm"
              key={index}
              onClick={item.onClick}
              disabled={item.disabled === undefined ? false : item.disabled}
            >
              {item.label}
            </Menu.Item>
          ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default ActionsMenu
